var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"position-absolute mt-2 ml-2",attrs:{"color":"white","small":""}},[_vm._v("search")]),_vm._v(" "),_c('div',{staticClass:"appTopSearch pl-4 d-flex",attrs:{"contenteditable":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f26dc31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/AppTopSearch.vue
// module id = null
// module chunks = 